<div class="margin-left-30">
  <div *ngIf="listDescriptionDefaultSatisfaction.length === 0">
    chargement ...
  </div>
  <div *ngIf="listDescriptionDefaultSatisfaction.length > 0">
    <h5 class="font-size-22">Exprimez le degré d'accord pour chacune des affirmations suivantes :</h5>
    <label class="label-satisfaction"
      >1 = Pas du tout d'accord ; 2 = Plutôt pas d'accord ; 3 = Relativament d'accord ; 4 = Plutôt d'accord ; 5 = Tout à
      fait d'accord</label
    >
    <div class="row">
      <span class="float-left">AFFIRMATION</span>
      <div class="float-right ">
        <span class="margin-right-92" *ngFor="let i of [1, 2, 3, 4, 5]"> {{ i }}</span>
      </div>
    </div>

    <div class="row" *ngFor="let elem of listDescriptionDefaultSatisfaction">
      <span class="float-left width-55 " [id]="elem.id" *ngIf="elem.libelle">{{ elem.libelle }} </span>
      <div class="float-right">
        <span class=" margin-right-85 " *ngFor="let i of [1, 2, 3, 4, 5]">
          <input
            [disabled]="already_completed"
            [id]="elem.id + '-' + i"
            [checked]="checkCheckedBoxDefault(elem.id, i)"
            (click)="updateCheckedDefaultQuestion(elem.id, i, $event)"
            type="checkbox"
            class="checkbox primary-border-bottom-right"
          />
        </span>
      </div>
    </div>
  </div>
  <div class="remarque-satisfaction" [hidden]="listDescriptionDefaultSatisfaction.length === 0">
    <h5 class="font-size-22">Remarques et suggestions de l'apprenant :</h5>
    <div class="input-field uk-margin width-100">
      <input [disabled]="already_completed" #note class="width-100" kendoTextBox [value]="satisfaction_note" />
    </div>
  </div>
  <div *ngIf="listDescriptionOptionalSatisfaction.length !== 0">
    <h5 class="font-size-22">Estimation du niveau de compétence pour chaque objectif identifié :</h5>
    <label class="label-satisfaction"
      >0 = pas du tout capable et 10 = tout à fait capable. Cochez la case en fin de ligne si l'apprenant estime avoir
      l'occasion de mettre en oeuvre la compétence sur son lieu de travail.</label
    >

    <div class="grid-container">
      <div class="grid-item margin-top-20">
        <span>COMPÉTENCE</span>
      </div>
      <div class="grid-item margin-left-175">
        <div class="grid-title ">
          <span>AVANT LA FORMATION</span>
        </div>
        <span class="margin-left-16" *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"> {{ i }}</span>
      </div>
      <div class="grid-item ">
        <div class="grid-title ">
          <span>APRÈS LA FORMATION</span>
        </div>
        <span class="margin-left-16" *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"> {{ i }}</span>
      </div>
      <div class="grid-item text-style">
        <span class="margin-top-20">MISE EN OEUVRE</span>
      </div>
    </div>

    <div class="grid-container" *ngFor="let elem of listDescriptionOptionalSatisfaction">
      <div class="grid-item">
        <span class="float-left" [id]="'optional-' + elem.id" style="width: 225px" *ngIf="elem.libelle"
          >{{ elem.libelle }}
        </span>
      </div>
      <div class="grid-item  ">
        <span class="margin-left-8-5" *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
          <input
            [disabled]="already_completed"
            [id]="'before-' + elem.id + '-' + i"
            [checked]="checkCheckedBoxOptionalBefore(elem.id, i)"
            (click)="updateCheckedOptionalBeforeQuestion(elem.id, i, $event)"
            type="checkbox"
            class="checkbox primary-border-bottom-right "
          />
        </span>
      </div>
      <div class="grid-item" style="margin-left: -40px">
        <span class="margin-left-8-5" *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
          <input
            [disabled]="already_completed"
            [id]="'after-' + elem.id + '-' + i"
            (click)="updateCheckedOptionalAfterQuestion(elem.id, i, $event)"
            [checked]="checkCheckedBoxOptionalAfter(elem.id, i)"
            type="checkbox"
            class="checkbox  primary-border-bottom-right"
          />
        </span>
      </div>
      <div class="grid-item margin-right-70 ">
        <input
          [disabled]="already_completed"
          (click)="updateCheckedImplementationWork(elem.id, $event)"
          [checked]="checkCheckedBoxOptionalImplementationWork(elem.id)"
          type="radio"
          class="checkbox primary-border-bottom-right"
        />
      </div>
    </div>
  </div>
  <br /><br />
  <div class="uk-column-2-6 k-text-center">
    <button
      [hidden]="already_completed"
      kendoButton
      (click)="updateSatisfactionValue()"
      [ngClass]="{ 'primary-background': !loadingUpdate, 'secondary-background': loadingUpdate }"
      *ngIf="listDescriptionDefaultSatisfaction.length > 0"
    >
      Valider
    </button>
  </div>
</div>

<div class="example-wrapper">
  <kendo-dialog *ngIf="openeUpdateDialog" (close)="closeDialog()" [minWidth]="250" [width]="450">
    <p style="margin: 30px; text-align: center;">
      <ng-container *ngIf="!errorUpdate && !loadingUpdate; else errorUpdateTemplete">
        <span class="k-icon k-i-check-outline primary-color" style="font-size: 64px;"></span>
        <br />
        <br />
        Votre formulaire de satisfaction est envoyé. Merci pour votre avis !
      </ng-container>
      <ng-template #errorUpdateTemplete>
        <ng-container *ngIf="loadingUpdate && !errorUpdate; else errorUpdateTempleteFormServer">
          <span class="k-icon k-icon k-i-loading primary-color" style="font-size: 64px;"></span>
          <br />
          <br />
          chargement ....
        </ng-container>
        <ng-template #errorUpdateTempleteFormServer>
          <span class="k-icon k-i-close-outline alert-color" style="font-size: 64px;"></span>
          <br />
          <br />
          {{ errorMsg }}
        </ng-template>
      </ng-template>
    </p>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeDialog()" [primary]="true">Ok</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</div>
